export const noty = {
  done: 'Data changed successfully',
  error: 'Kesalahan',
  link_copied: 'Link dikopi',
  text_copied: 'Dikopi',
  export_started:
    'We prepare statistics detailing for you. You will receive a notification with a download link when the file is available.',
  export_pbx:
    'We are preparing an archive of records for you. You will receive a notification with a download link when the file is available.'
};
